import { buildQuery, containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/documentAssignment";

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, orderBy: "id desc" });
    return request(`${resource}/getPostamatPointsList${query}`, { method: "GET" }, { countInHeaders: true });
};

const getPostamatPointsList = (params?: {}) =>
    request(`${resource}/getPostamatPointsList${params ? containsQuery(params) : ""}`, { method: "GET" });
const getItem = (params: { id: number }) =>
    request(`${resource}/getPostamatPointsList${buildQuery({ filter: { id: Number(params.id) } })}`, {
        method: "GET",
    }).then((res) => res && res[0]);
const apply = (params: {}) => alertRequest(`${resource}/applyPostamatPoint`, body(params));
const delItem = (params: {}) => alertRequest(`${resource}/deletePostamatPoint`, body(params));

export { apply, index, delItem, getPostamatPointsList, getItem };
